// PPS CRM - Wallet Module
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function Wallet() {
  const [available, setAvailable] = useState(0);
  const [pending, setPending] = useState(0);
  const [loading, setLoading] = useState(true);
  const [cashoutLoading, setCashoutLoading] = useState(false);

  useEffect(() => {
    fetchWallet();
  }, []);

  const fetchWallet = async () => {
    try {
      const response = await api.get('/api/wallet');
      setAvailable(Number(response.data.available || 0));
      setPending(Number(response.data.pending || 0));
    } catch (error) {
      console.error('Error fetching wallet:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCashout = async () => {
    setCashoutLoading(true);
    try {
      await api.post('/api/wallet/cashout');
      fetchWallet();
    } catch (error) {
      console.error('Error cashing out:', error);
    } finally {
      setCashoutLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Wallet</h2>

      {loading ? (
        <div className="card p-8 text-center">Loading...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="card">
            <h3 className="text-sm text-dark-gray mb-2">Available</h3>
            <div className="text-3xl font-bold text-success">${available.toFixed(2)}</div>
          </div>
          <div className="card">
            <h3 className="text-sm text-dark-gray mb-2">Pending</h3>
            <div className="text-3xl font-bold">${pending.toFixed(2)}</div>
          </div>
        </div>
      )}

      <div className="mt-6">
        <button
          onClick={handleCashout}
          disabled={cashoutLoading}
          className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark disabled:opacity-50"
        >
          {cashoutLoading ? 'Processing...' : 'Cash Out'}
        </button>
      </div>
    </div>
  );
}
